module.exports = ".icon-close-accessibility:focus-visible {\n  outline: 3px solid var(--accessibilityYellowColor);\n}\n"